import {
  Box,
  Button,
  Menu, alpha, styled,
} from '@mui/material';
import { spaceCadet, ultraMarine } from '../../../../../../../../../../utils/colors';

const StyledBox = styled(Box)({
  backgroundColor: 'white',
  padding: '8px 12px',
  borderRadius: 4,
  border: `1px solid ${alpha(spaceCadet[300], 0.3)}`,
  flexShrink: 0,
  display: 'flex',
  flexDirection: 'column',
  gap: 8,

  '& > .MuiBox-root.header': {
    alignSelf: 'end',
    '& > .MuiTypography-body1': {
      padding: '4px 8px',
      lineHeight: '14px',
      gap: 4,
      fontWeight: 700,
      borderRadius: 4,
      backgroundColor: ultraMarine[100],
      color: ultraMarine[600],
      fontSize: 10,
    },
  },
  '& > .MuiBox-root.content': {
    display: 'flex',
    flexDirection: 'column',
    gap: 8,
    '& > .MuiBox-root.actions': {
      display: 'flex',
      justifyContent: 'flex-start',
      gap: 8,
      '& .MuiButtonBase-root': {
        padding: '4px 10px',
        fontSize: 14,
        textTransform: 'none',
      },
    },
    '& .MuiFormControl-root': {
      '&:first-of-type': {
        width: 'max-content',
      },
      '& > .MuiInputBase-root': {
        fontSize: 14,
        padding: 8,
        '& > .MuiInputBase-input': {
          padding: 0,
        },
      },
    },
  },
});

export const StyledButton = styled(Button)({
  padding: '4px 8px',
  lineHeight: '14px',
  gap: 4,
  fontWeight: 700,
  borderRadius: 4,
  backgroundColor: ultraMarine[100],
  color: ultraMarine[600],
  fontSize: 10,
  '& svg': {
    fontSize: 16,
  },
});

export const StyledMenu = styled(Menu)({
  '& .MuiMenuItem-root': {
    fontSize: 14,
    lineHeight: '24px',
    color: spaceCadet[500],
    padding: '4px 8px',

    '& svg': {
      fontSize: 20,
      marginRight: 4,
      color: spaceCadet[500],
    },
  },
});

export default StyledBox;
